import { createRoot, hydrateRoot } from 'react-dom/client'
import './assets/styles/global.css'
import App from './App.tsx'
import ErrorBoundary from './components/common/ErrorBoundary'
import { PRERENDERED_ROUTES } from './prerender-routes'

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const app = (
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Marketing routes are prerendered at build time by prerender.mjs - hydrate
// them so React reuses the existing DOM instead of wiping and re-rendering
// (better LCP). All other routes are served a prerendered shell with the
// wrong content, so discard it and mount fresh.
const path = window.location.pathname.replace(/\/+$/, '') || '/';
if (rootElement.hasChildNodes() && PRERENDERED_ROUTES.includes(path)) {
  hydrateRoot(rootElement, app);
} else {
  rootElement.innerHTML = '';
  createRoot(rootElement).render(app);
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
  });
}
